module.exports = __webpack_public_path__ + "img/serviddepng.ece5e570.png";